/* noop */
"use strict";


//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-hot-loader/lib/patch.prod.js
// module id = 998
// module chunks = 0